import { call, put, take } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import * as types from 'src/state/ducks/master/types';
import * as actions from 'src/state/ducks/master/actions';
import * as api from 'src/state/ducks/master/api';
import { Status } from 'src/constants/Interface';

function* dispatchGetTags() {
  while (true) {
    yield take(types.GET_TAGS);
    try {
      const res = yield call(api.getTags);
      if (res.status === Status.SUCCESS) {
        yield put(actions.successGetTags(res));
      } else if (res.status === Status.INVALID) {
        yield put(actions.failGetTags(res));
      } else {
        console.error(res.error);
      }
    } catch (err) {
      throw err;
    }
  }
}

function* dispatchCreateTag() {
  while (true) {
    const action = yield take(types.CREATE_TAG);
    try {
      const res = yield call(api.createTag, action.payload);
      if (res.status === Status.SUCCESS) {
        yield put(actions.successCreateTag(res));
      } else if (res.status === Status.INVALID) {
        yield put(actions.failCreateTag(res));
      } else {
        console.error(res.error);
      }
    } catch (err) {
      throw err;
    }
  }
}

function* dispatchUpdateTag() {
  while (true) {
    const action = yield take(types.UPDATE_TAG);
    try {
      const res = yield call(api.updateTag, action.payload);
      if (res.status === Status.SUCCESS) {
        yield put(actions.successUpdateTag(res));
      } else if (res.status === Status.INVALID) {
        yield put(actions.failUpdateTag(res));
      } else {
        console.error(res.error);
      }
    } catch (err) {
      throw err;
    }
  }
}

function* dispatchCreatePushMessage() {
  while (true) {
    const action = yield take(types.CREATE_PUSH_MESSAGE);
    try {
      const res = yield call(api.createPushMessage, action.payload);
      if (res.status === Status.SUCCESS) {
        yield put(actions.successPushMessage(res));
        yield put(push('/admin/pushnotifcation/complete'));
      } else {
        yield put(actions.failPushMessage(res));
      }
    } catch (err) {
      yield put(
        actions.failPushMessage({
          status: Status.FAILURE,
          error: {
            code: 400,
            message: err.message,
          },
        }),
      );
    }
  }
}

const masterSaga = [
  dispatchGetTags(),
  dispatchCreateTag(),
  dispatchUpdateTag(),
  dispatchCreatePushMessage(),
];

export default masterSaga;
